import ROUTE from '@shared/modules/assessment/router/names'

export default [
  {
    path: '/assessment',
    redirect: '/assessment/login',
  },
  {
    path: '/assessment/login',
    name: ROUTE.ASSESSMENT_LOGIN,
    component: () => import('@shared/modules/assessment/views/Login.vue'),
  },
  {
    path: '/assessment/self-test',
    component: () =>
      import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTest.vue'),
    children: [
      {
        path: 'welcome',
        name: ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestWelcome.vue'),
        meta: {
          name: 'onb_get_started',
        },
      },
      {
        path: 'precautions-msk',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_MSK,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPrecautions_MSK_EU.vue'),
        meta: {
          name: 'onb_precautions',
        },
      },
      {
        path: 'precautions-copd',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_COPD,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPrecautions_COPD.vue'),
        meta: {
          name: 'onb_precautions',
        },
      },
      {
        path: 'about',
        name: ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestAboutDE.vue'),
        meta: {
          name: 'onb_basic_info',
        },
      },
      {
        path: 'activities',
        name: ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestActivities.vue'),
        meta: {
          name: 'onb_physical_activity',
        },
      },
      {
        path: 'worst-pain-location',
        name: ROUTE.ASSESSMENT_SELF_TEST_WORST_PAIN_LOCATION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestWorstPainLocation.vue'),
        meta: {
          name: 'onb_pain_locations',
        },
      },
      {
        path: 'pain-duration',
        name: ROUTE.ASSESSMENT_SELF_TEST_PAIN_DURATION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPainDuration.vue'),
        meta: {
          name: 'onb_pain_duration',
        },
      },
      {
        path: 'pain-intensity',
        name: ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPainIntensity.vue'),
        meta: {
          name: 'onb_pain_intensity_24',
        },
      },
      {
        path: 'fear-of-movement',
        name: ROUTE.ASSESSMENT_SELF_TEST_FEAR_OF_MOVEMENT,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestFearOfMovement.vue'),
        meta: {
          name: 'onb_fear_of_movement',
        },
      },
      {
        path: 'complete',
        name: ROUTE.ASSESSMENT_SELF_TEST_COMPLETE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestComplete.vue'),
        meta: {
          name: 'onb_finish_congratulations',
        },
      },
      {
        path: 'pre-signup-reflection-pain-location',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PAIN_LOCATION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPreSignupReflection.vue'),
        meta: {
          name: 'onb_reflection_pain_location',
        },
      },
      {
        path: 'pre-signup-reflection-pain-level',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PAIN_LEVEL,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPreSignupPainLevelReflection.vue'),
        meta: {
          name: 'onb_reflection_pain_level',
        },
      },
      {
        path: 'pre-signup-reflection-pain-duration',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PAIN_DURATION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPreSignupReflection.vue'),
        meta: {
          name: 'onb_reflection_pain_duration',
        },
      },
      {
        path: 'previous-treatment',
        name: ROUTE.ASSESSMENT_SELF_TEST_PREVIOUS_TREATMENT,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPreviousTreatment.vue'),
        meta: {
          name: 'onb_previous_treatment',
        },
      },
      {
        path: 'pre-signup-reflection-previous-treatment',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PREVIOUS_TREATMENT,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPreSignupReflection.vue'),
        meta: {
          name: 'onb_reflection_previous_treatment',
        },
      },
      {
        path: 'goal',
        name: ROUTE.ASSESSMENT_SELF_TEST_GOAL,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestGoal.vue'),
        meta: {
          name: 'onb_goal_selection',
        },
      },
      {
        path: 'pre-signup-complete',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_COMPLETE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTest/SelfTestPreSignupComplete.vue'),
        meta: {
          name: 'onb_finish_pre_signup',
        },
      },
      {
        path: 'pre-subscription-complete',
        name: ROUTE.ASSESSMENT_SELF_TEST_PRE_SUBSCRIPTION_COMPLETE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestPreSubscription/SelfTestPreSubscriptionComplete.vue'),
        meta: {
          name: 'onb_finish_pre_subscription',
        },
      },
      {
        path: '',
        redirect: 'welcome',
      },
    ],
  },
  {
    path: '/assessment/cat/welcome',
    name: ROUTE.ASSESSMENT_CAT_WELCOME,
    component: () =>
      import('@shared/modules/assessment/views/QuestionnaireCAT/CATWelcome.vue'),
    meta: {
      name: 'cat_welcome',
    },
  },
  {
    path: '/assessment/cat/questions',
    component: () =>
      import('@shared/modules/assessment/views/QuestionnaireCAT/CATQuestions.vue'),
    name: ROUTE.ASSESSMENT_CAT_QUESTIONS,
    meta: {
      name: 'cat_questions',
    },
  },
  {
    path: '/assessment/cat/completed',
    component: () =>
      import('@shared/modules/assessment/views/QuestionnaireCAT/CATCompleted.vue'),
    name: ROUTE.ASSESSMENT_CAT_COMPLETED,
    meta: {
      name: 'cat_completed',
    },
  },
  {
    path: '/assessment/self-test-reevaluations',
    redirect: '/assessment/self-test-reevaluations/pain-average',
  },
  {
    path: '/assessment/self-test-reevaluations',
    component: () =>
      import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluations.vue'),
    children: [
      {
        path: 'pain-average',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAIN_AVERAGE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPainAverage.vue'),
        meta: {
          name: 'monthly_checkup_pain_average',
        },
      },
      {
        path: 'pain-worst',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAIN_WORST,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPainWorst.vue'),
        meta: {
          name: 'monthly_checkup_pain_worst',
        },
      },
      {
        path: 'pain-now',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAIN_NOW,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPainNow.vue'),
        meta: {
          name: 'monthly_checkup_pain_now',
        },
      },
      {
        path: 'physical-activity-chores',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_CHORES,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPhysicalActivityChores.vue'),
        meta: {
          name: 'monthly_checkup_physical_activity_chores',
        },
      },
      {
        path: 'physical-activity-stairs',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_STAIRS,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPhysicalActivityStairs.vue'),
        meta: {
          name: 'monthly_checkup_physical_activity_stairs',
        },
      },
      {
        path: 'physical-activity-walk',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_WALK,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPhysicalActivityWalk.vue'),
        meta: {
          name: 'monthly_checkup_physical_activity_walk',
        },
      },
      {
        path: 'physical-activity-errands',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_ERRANDS,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPhysicalActivityErrands.vue'),
        meta: {
          name: 'monthly_checkup_physical_activity_errands',
        },
      },
      {
        path: 'fear-of-movement',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_FEAR_OF_MOVEMENT,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsFearOfMovement.vue'),
        meta: {
          name: 'monthly_checkup_fear_of_movement',
        },
      },
      {
        path: 'productivity',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PRODUCTIVITY,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsProductivity.vue'),
        meta: {
          name: 'monthly_checkup_productivity',
        },
      },
      {
        path: 'confidence',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_CONFIDENCE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsConfidence.vue'),
        meta: {
          name: 'monthly_checkup_confidence',
        },
      },
      {
        path: 'phq-interest',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHQ_INTEREST,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_phq_interest',
        },
      },
      {
        path: 'phq-feeling',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHQ_FEELING,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_phq_feeling',
        },
      },
      {
        path: 'gad-nervous',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_NERVOUS,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_nervous',
        },
      },
      {
        path: 'gad-control',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_CONTROL,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_control',
        },
      },
      {
        path: 'gad-worrying',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_WORRYING,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_worrying',
        },
      },
      {
        path: 'gad-relaxing',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_RELAXING,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_relaxing',
        },
      },
      {
        path: 'gad-restless',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_RESTLESS,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_restless',
        },
      },
      {
        path: 'gad-irritable',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_IRRITABLE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_irritable',
        },
      },
      {
        path: 'gad-afraid',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_AFRAID,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsRadioColumnView.vue'),
        meta: {
          name: 'monthly_checkup_gad_afraid',
        },
      },
      {
        path: 'past-consultations',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAST_CONSULTATIONS,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPastConsultations.vue'),
        meta: {
          name: 'monthly_checkup_past_consultations',
        },
      },
      {
        path: 'past-medications',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAST_MEDICATIONS,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPastMedication.vue'),
        meta: {
          name: 'monthly_checkup_past_medications',
        },
      },
      {
        path: 'complete',
        name: ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_COMPLETE,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsComplete.vue'),
        meta: {
          name: 'monthly_checkup_complete',
        },
      },
    ],
  },
  {
    path: '/assessment/renewal',
    component: () =>
      import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessment.vue'),
    children: [
      // Redirect by name, not by path: a relative path target ('check-in') is
      // resolved against the current location rather than this parent, which is
      // why the sibling flows above repeat their full path instead.
      {
        path: '',
        redirect: { name: ROUTE.ASSESSMENT_RENEWAL_CHECK_IN },
      },
      {
        path: 'check-in',
        name: ROUTE.ASSESSMENT_RENEWAL_CHECK_IN,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentCheckIn.vue'),
        meta: {
          name: 'renewal_assessment_check_in',
        },
      },
      {
        path: 'pgic',
        name: ROUTE.ASSESSMENT_RENEWAL_PGIC,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentPGIC.vue'),
        meta: {
          name: 'renewal_assessment_pgic',
        },
      },
      {
        path: 'pgic-reflection',
        name: ROUTE.ASSESSMENT_RENEWAL_PGIC_REFLECTION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentReflection.vue'),
        meta: {
          name: 'renewal_assessment_pgic_reflection',
        },
      },
      {
        path: 'goal-achievement',
        name: ROUTE.ASSESSMENT_RENEWAL_GOAL_ACHIEVEMENT,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentTherapyFeedback.vue'),
        meta: {
          name: 'renewal_assessment_goal_achievement',
        },
      },
      {
        path: 'goal-achievement-reflection',
        name: ROUTE.ASSESSMENT_RENEWAL_GOAL_ACHIEVEMENT_REFLECTION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentReflection.vue'),
        meta: {
          name: 'renewal_assessment_goal_achievement_reflection',
        },
      },
      {
        path: 'therapy-feedback',
        name: ROUTE.ASSESSMENT_RENEWAL_THERAPY_FEEDBACK,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentTherapyFeedback.vue'),
        meta: {
          name: 'renewal_assessment_therapy_feedback',
        },
      },
      {
        path: 'therapy-feedback-reflection',
        name: ROUTE.ASSESSMENT_RENEWAL_THERAPY_FEEDBACK_REFLECTION,
        component: () =>
          import('@shared/modules/assessment/views/QuestionnaireRenewalAssessment/RenewalAssessmentReflection.vue'),
        meta: {
          name: 'renewal_assessment_therapy_feedback_reflection',
        },
      },
    ],
  },
  {
    path: '/assessment/completed',
    name: ROUTE.ASSESSMENT_COMPLETION,
    component: () => import('@shared/modules/assessment/views/Completion.vue'),
  },
]
